import {
  TabPanels as HeadlessTabPanels,
  type TabPanelsProps as HeadlessTabPanelsProps,
} from "@headlessui/react";
import { type ElementType } from "react";

type TabPanelsProps<TTag extends ElementType = "div"> =
  HeadlessTabPanelsProps<TTag>;

export default function TabPanels<TTag extends ElementType = "div">(
  props: TabPanelsProps<TTag>,
) {
  return <HeadlessTabPanels {...(props as any)} />;
}
